/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component } from 'react';
import { Spinner, Tooltip, OverlayTrigger, Image } from 'react-bootstrap';
import { Loading } from 'react-loading-dot';
import { SketchPicker } from 'react-color';
import { PageView, ModalView, Event } from "../GoogleAnalytics";
import PartnerService from "../../services/partner.service";
import AlertService from "../../services/alerts.service";

import LongArrowUpIcon from '@mui/icons-material/ArrowUpward';
import LongArrowDownIcon from '@mui/icons-material/ArrowDownward';

import moment from "moment";
import trainingSessionService from "../../services/trainingSession.service";
import {Equipment, GraphTypes} from "../../componentObjects";
import Loader from "../Loader/Loader";
import GraphComponent from "../Graph/GraphComponent";

const COLORS = ['#0033a0', '#3ed3c2', '#ff7555', '#ff9900', '#7d8ee2'];

const initState = {
    loading: false,
    alertTableLoading: false,
    selected: -1,
    alertSelected: false,
    currentAlert: [],
    currentAlertType: "",
    //alertCountInfo: {},
    //trainingList: [],
    columnList: [],
    columnAltered: false,
    columnSort: {
        enabled: false,
        type: null,
        reverse: false
    },
    showColorPicker: false,
    selectedColor: -1,
    runTableLoading: false,
    runAssetSelected: false,
    currentAssetId: "",
    assetRunList: [],
    selectedRuns: [],
    graphedRuns: [],
    dataList: [],
    chartDataList: [],
    rawDataList: [],
    last150DataList: [],
    runData: {},
    allSelected: false,
    allGraphed: false
};

class FuranceAlertTrainingReview extends Component {
    static displayName = FuranceAlertTrainingReview.name;
    _isMounted = false;

    constructor(props) {
        super(props);

        this.loadInfo = this.loadInfo.bind(this);
        this.populateInfo = this.populateInfo.bind(this);
        this.onColumnClick = this.onColumnClick.bind(this);
        this.columnSort = this.columnSort.bind(this);
        this.onAlertRowClick = this.onAlertRowClick.bind(this);
        this.onShowAllClick = this.onShowAllClick.bind(this);

        this.onAlertAssetClick = this.onAlertAssetClick.bind(this);
        this.onBackClick = this.onBackClick.bind(this);

        this.onSelectAll = this.onSelectAll.bind(this);
        this.handleRunCheck = this.handleRunCheck.bind(this);
        this.onGraphAll = this.onGraphAll.bind(this);
        this.handleGraphRunCheck = this.handleGraphRunCheck.bind(this);

        this.handleColorClick = this.handleColorClick.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.closeColorPicker = this.closeColorPicker.bind(this);

        this.state = {
            loading: false,

            /* all assets page */
            alertTableLoading: false,
            selected: -1,
            alertSelected: false,
            currentAlert: [],
            currentAlertType: "",

            alertCountInfo: {},
            trainingList: [],

            columnList: [],
            columnAltered: false,
            columnSort: {
                enabled: false,
                type: null,
                reverse: false
            },

            orgId: 1,
            showAllTraining: true,//false,
            showShowAllBtn: false,

            /* device page */
            showColorPicker: false,
            selectedColor: -1,

            runTableLoading: false,
            runAssetSelected: false,
            currentAssetId: "",
            assetRunList: [],

            selectedRuns: [],
            graphedRuns: [],
            dataList: [],
            chartDataList: [],
            rawDataList: [],
            last150DataList: [],
            longRunList: [],
            runData: {},
            allSelected: false,
            allGraphed: false,

            visibility: {
                rla: false,
                lra: false,
                fla: false
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        this.loadInfo();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentPartnerId !== this.props.currentPartnerId) {
            this.loadInfo();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    /** Alert Count Training Review **/

    loadInfo() {
            this.setState({ loading: true }, async () => {
                let orgId = this.props.currentPartnerId;
                let showBtn = true;
                let showAll = false;
                if (this.props.loggedInOrg !== "LifeWhere") {
                    showBtn = false;
                }
                else if (this.props.showAllTraining) {
                    showAll = true;
                    orgId = 1;
                }

                this.setState({
                    orgId: orgId,
                    showAllTraining: showAll,
                    showShowAllBtn: showBtn
                }, async () => {
                    await this.populateInfo();
                })
            });
    }

    async populateInfo() {
        await trainingSessionService.getalertcountinfo(this.state.orgId, Equipment.FURNACE)
            .then(response => {
                if (this._isMounted) {
                    if (response != null && response !== {}) {
                        this.setState({ alertCountInfo: response }, () => {
                            this.setState({
                                trainingList: this.state.alertCountInfo.trainingAlerts !== undefined ? this.state.alertCountInfo.trainingAlerts : [],
                                loading: false
                            });
                        });
                    }
                    else {
                        this.setState({ loading: false });
                    }
                }

            })
            .catch(e => {
                console.log(e);
            });
    }

    onShowAllClick() {
        Event("Show All Clicked", "User clicked show all in Furnace Alert Training Review", "Show All Clicked");
        this.setState({ loading: true, showAllTraining: !this.state.showAllTraining }, () => {
            this.props.setShowAllTraining(this.state.showAllTraining);
            this.setState({ orgId: this.state.showAllTraining ? 1 : this.props.currentPartnerId }, async () => {
                await this.populateInfo();
            });
        });
    }

    onColumnClick(selectedCol) {
        const colSort = this.state.columnSort;
        let newSort = colSort;
        const tableList = this.state.trainingList;
        let trainingAlerts = tableList;
        let colAlerts = [];
        let colAltered = false;

        if (colSort.enabled) {
            if (colSort.type == selectedCol) {
                if (colSort.reverse) {
                    newSort = {
                        enabled: false,
                        type: null,
                        reverse: false
                    };
                    colAlerts = this.columnSort(trainingAlerts, "RUNCOUNT", false); /* default sort by is RUNCOUNT */
                    colAltered = false;
                }
                else {
                    newSort.reverse = true;
                    colAlerts = this.columnSort(trainingAlerts, selectedCol, true);
                    colAltered = true;
                }
            }
            else {
                newSort = {
                    enabled: true,
                    type: selectedCol,
                    reverse: false
                };
                colAlerts = this.columnSort(trainingAlerts, selectedCol, false);
                colAltered = true;
            }
        }
        else {
            newSort = {
                enabled: true,
                type: selectedCol,
                reverse: false
            };
            colAlerts = this.columnSort(trainingAlerts, selectedCol, false);
            colAltered = true;
        }

        this.setState({ columnSort: newSort, columnList: colAlerts }, () => {
            this.setState({ columnAltered: colAltered });
        });
    }

    columnSort(list, col, isReverse) {
        let colAlerts = [];
        let trainingAlerts = list;

        if (col === "ALERTTYPE") {
            colAlerts = trainingAlerts.sort((a, b) => {
                const nameA = a.alertType.toLocaleUpperCase();
                const nameB = a.alertType.toLocaleUpperCase();

                return nameA.localeCompare(nameB);
            });
        }
        else if (col === "ASSETCOUNT" || col === "RUNCOUNT") {
            colAlerts = trainingAlerts.sort((a, b) => {
                const valA = col === "ASSETCOUNT" ? a.assetCount : a.runCount;
                const valB = col === "ASSETCOUNT" ? b.assetCount : b.runCount;

                return valB - valA;
            })
        }
        else if (col === "ASSETPERCENTAGE") {
            colAlerts = trainingAlerts.sort((a, b) => {
                const valA = (a.assetCount / this.state.alertCountInfo.assetCount) * 100;
                const valB = (b.assetCount / this.state.alertCountInfo.assetCount) * 100;

                return valB - valA;
            });
        }
        else {
            colAlerts = trainingAlerts.sort((a, b) => {
                const valA = (a.runCount / this.state.alertCountInfo.runCount) * 100;
                const valB = (b.runCount / this.state.alertCountInfo.runCount) * 100;

                return valB - valA;
            });
        }

        if (isReverse) {
            colAlerts = colAlerts.reverse();
        }

        return colAlerts;
    }

    onAlertRowClick(index) {
        let x = index;
        let alert = this.state.trainingList[x];
        let alertType = this.state.trainingList[x].alertType;

        this.setState({
            currentAlert: alert,
            currentAlertType: alertType,
            selected: x,
            alertSelected: true,
            runAssetSelected: false,
            alertTableLoading: true
        }, () => {
            this.setState({
                alertTableLoading: false
            });
        });
    }

    /** Alert Type Training Review **/

    onBackClick() {
        Event("Back Clicked", "User clicked back button in Furnace Alert Training Review", "Back Clicked");
        this.setState(initState);
    }

    onAlertAssetClick(id) {
        this.setState({
            runTableLoading: true,
            runAssetSelected: true,
            currentAssetId: id
        }, () => {
            this.setState({
                assetRunList: this.state.currentAlert.runsByAssetDict[this.state.currentAssetId]
            }, async () => {
                await AlertService.gettrainingrunlistdata(this.state.currentAssetId, true, Equipment.FURNACE, this.state.assetRunList)
                    .then(response => {
                        this.setState({
                            runData: response.data,
                            runTableLoading: false
                        });
                    })
                    .catch(e => {
                        console.log(e);
                        this.setState({ runTableLoading: false });
                    });
            });
        });
    }

    onSelectAll() {
        Event("Select All Clicked", "User clicked select all in Furnace Alert Training Review", "Select All Clicked");
        let selectedRuns = [];

        this.setState({ allSelected: !this.state.allSelected }, () => {
            if (this.state.allSelected)
                selectedRuns = this.state.assetRunList;

            this.setState({ selectedRuns: selectedRuns });
        });
    }

    handleRunCheck(e) {
        const index = e.target.value;
        const run = this.state.assetRunList[index];
        let selectedRuns = this.state.selectedRuns;

        if (e.target.checked) {
            selectedRuns = selectedRuns.concat(run);
            this.setState({ selectedRuns: selectedRuns });
        }
        else {
            selectedRuns = selectedRuns.filter(s => s.runId !== run.runId);
            this.setState({ selectedRuns: selectedRuns });
        }
    }

    getDataObj(name, dataArr, color, dashStyle = 'solid', pointStart = null) {
        let dataObj = {
            name: name,
            data: dataArr,
            color: color,
            dashStyle: dashStyle,
            type: 'line',
            opacity: 1,
            marker: {
                enabledThreshold: 0
            },
            yAxis: 0
        };
        if (pointStart !== null) {
            dataObj.pointStart = pointStart;
            dataObj.pointInterval = 1000;
        }
        return dataObj;
    }
    
    onGraphAll() {
        Event("Graph All Clicked", "User clicked graph all in Furnace Alert Training Review", "Graph All Clicked");
        let graphedRuns = [];
        let selectedRuns = [];
        let dataList = [];
        let chartDataList = [];
        let rawDataList = [];
        let last150DataList = [];
        let dataMax = 0;
        let rawMax = 0;

        this.setState({ allGraphed: !this.state.allGraphed }, () => {
            if (this.state.allGraphed) {
                selectedRuns = this.state.assetRunList;
                this.setState({ loading: true }, async () => {
                    await AlertService.gettrainingrunlistdata(this.state.currentAssetId, false, Equipment.FURNACE, this.state.assetRunList)
                        .then(response => {
                            if (this._isMounted)
                                this.setState({
                                    runData: response.data
                                }, () => {
                                    for (let i = 0; i < this.state.assetRunList.length; i++) {
                                        const run = this.state.assetRunList[i];
                                        let series = this.state.runData[run.runId];
                                        let seriesRuns = series.series;

                                         /* has already been loaded */
                                        graphedRuns = graphedRuns.concat(run);
                                        dataList = dataList.concat(series);
                                        for (let i = 0; i < seriesRuns.length; i++) {
                                            if (seriesRuns[i].length > dataMax) {
                                                dataMax = seriesRuns[i].length;
                                            }
                                        }
                                        if (series.dataMax > rawMax) {
                                            rawMax = series.dataMax;
                                        }
                                        
                                        for (let j = 0; j < seriesRuns.length; j++) {
                                            let dataName = `${run.runId}`;
                                            let seriesRun = seriesRuns[j];
                                            chartDataList = this.props.getGraphData(chartDataList, dataName, seriesRun, series.color); 
                                            last150DataList = this.props.getLastGraphData(last150DataList, dataName, seriesRun, series.color); 
                                        }
                                    }

                                    this.setState({
                                        loading: false,
                                        graphedRuns: graphedRuns,
                                        selectedRuns: selectedRuns,
                                        dataList: dataList,
                                        chartDataList: chartDataList,
                                        rawDataList: rawDataList,
                                        last150DataList: last150DataList,
                                        dataMax: dataMax,
                                        rawMax: rawMax
                                    });
                                });
                        })
                        .catch(e => {
                            console.log(e);
                            this.setState({ loading: false, message: "Failed to fetch graph data for all runs" });

                            setTimeout(() => {
                                this.setState({
                                    message: ""
                                });
                            }, 3000);
                        });
                });
            }
            else {
                selectedRuns = this.state.selectedRuns;

                this.setState({
                    graphedRuns: graphedRuns,
                    selectedRuns: selectedRuns,
                    dataList: dataList,
                    dataMax: dataMax,
                    rawMax: rawMax,
                    chartDataList: chartDataList,
                    rawDataList: rawDataList,
                    last150DataList: last150DataList
                });
            }
        });
    }

    async handleGraphRunCheck(e) {
        const index = e.target.value;
        const run = this.state.assetRunList[index];
        const graphRunId = run.runId;

        let graphedRuns = this.state.graphedRuns;
        let selectedRuns = this.state.selectedRuns;
        let runData = this.state.runData;
        let dataList = this.state.dataList;
        let longRunList = this.state.longRunList;
        let chartDataList = this.state.chartDataList;
        let rawDataList = this.state.rawDataList;
        let last150DataList = this.state.last150DataList;

        let list = [];
        list = list.concat(run);

        if (e.target.checked) {
            this.setState({ loading: true }, async () => {
                await AlertService.gettrainingrunlistdata(this.state.currentAssetId, false, Equipment.FURNACE, list)
                    .then(response => {
                        if (this._isMounted) {
                            let responseData = response.data;
                            responseData[graphRunId].color = runData[graphRunId].color;
                            runData[graphRunId] = responseData[graphRunId];

                            let series = responseData[graphRunId];
                            longRunList = longRunList.concat(run);
                            graphedRuns = graphedRuns.concat(run);
                            selectedRuns = selectedRuns.concat(run);
                            dataList = dataList.concat(series);

                            let seriesRuns = series.series;
                            series.series = seriesRuns;

                            let seriesMax = 0;
                            for (let i = 0; i < seriesRuns.length; i++) {
                                let thisMax = seriesRuns[i].length;
                                if (thisMax > seriesMax) {
                                    seriesMax = thisMax;
                                }
                            }
                            
                            for (let j = 0; j < seriesRuns.length; j++) {
                                let dataName = `${run.runId}`;
                                let seriesRun = seriesRuns[j];
                                chartDataList = this.props.getGraphData(chartDataList, dataName, seriesRun, series.color); 
                                last150DataList = this.props.getLastGraphData(last150DataList, dataName, seriesRun, series.color); 
                            }

                            let dataMax = this.state.dataMax;
                            let rawMax = this.state.rawMax;
                            if (seriesMax > dataMax) {
                                dataMax = seriesMax;
                            }
                            if (series.dataMax > rawMax) {
                                rawMax = series.dataMax;
                            }

                            this.setState({
                                loading: false,
                                longRunList: longRunList,
                                graphedRuns: graphedRuns,
                                selectedRuns: selectedRuns,
                                dataList: dataList,
                                dataMax: dataMax,
                                rawMax: rawMax,
                                chartDataList: chartDataList,
                                rawDataList: rawDataList,
                                last150DataList: last150DataList
                            });
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        this.setState({ loading: false, message: "Failed to load graph data for selected run!" });

                        setTimeout(() => {
                            this.setState({
                                message: ""
                            });
                        }, 3000);
                    });
            })
        }
        else {
            longRunList = longRunList.filter(a => a.runId !== graphRunId);
            graphedRuns = graphedRuns.filter(a => a.runId !== graphRunId);
            dataList = dataList.filter(d => d.name !== graphRunId);
            chartDataList = chartDataList.filter(d => !d.name.includes(graphRunId));
            rawDataList = rawDataList.filter(d => !d.name.includes(graphRunId));
            last150DataList = last150DataList.filter(d => !d.name.includes(graphRunId));

            this.setState({ longRunList: longRunList, graphedRuns: graphedRuns, dataList: dataList, chartDataList: chartDataList, rawDataList: rawDataList, last150DataList: last150DataList });
        }
    }

    handleColorClick() {

    }

    handleColorChange() {

    }

    closeColorPicker() {

    }

    /** UI helpers **/

    getAssetPercentage(count) {
        let total = this.state.alertCountInfo.assetCount;
        let percentage = (count / total) * 100;
        percentage = percentage.toFixed(2);

        return (percentage + "%");
    }

    getRunPercentage(count) {
        let total = this.state.alertCountInfo.runCount;
        let percentage = (count / total) * 100;
        percentage = percentage.toFixed(2);

        return (percentage + "%");
    }

    getStartDate(date) {
        let dateStr = moment(date).format();
        return (dateStr);
    }

    renderGraph() {

        return (
            <div className="row no-gutters">
                <div className="col-sm-12 col-md-10">

                    <GraphComponent graphType={GraphTypes.ALERT} chartData={this.state.chartDataList} key={`${this.state.currentAssetId}-${this.state.chartDataList.length}-${this.state.dataList.length}-${this.state.visibility}`} assetType={Equipment.FURNACE} isTraining={true}
                        dataMax={this.state.dataMax} rawMax={this.state.rawMax} rawData={this.state.rawDataList} last150Data={this.state.last150DataList} rlaValue={this.state.dataList.length ? this.state.dataList[0].rla : null}
                        visibility={this.state.visibility} lraValue={this.state.dataList.length ? this.state.dataList[0].lra : null} flaValue={this.state.dataList.length ? this.state.dataList[0].fla : null} alertList={this.state.graphedRuns} assetId={this.state.currentAssetId} setLoading={this.setLoading} />

                </div>
            </div>
        );
    }

    renderAlertContent() {
        const { classes } = this.props;

        let alertLoader = this.state.alertTableLoading ?
            <Loader />
            : null;

        let tableContent = this.state.runAssetSelected && this.state.assetRunList !== undefined && this.state.assetRunList.length ?
            <tbody>
                {this.state.assetRunList.map((run, index) =>
                    <tr key={`${index}-${run.runId}`} data={index}>
                        <td>{run.runId}</td>
                        <td>{this.getStartDate(run.startTime)}</td>
                        <td>{this.getStartDate(run.endTime)}</td>
                        <td>{run.alertType}</td>
                        <td>
                            <input type="checkbox" value={index/*run.runId*/} id={`${run.runId}-select`} checked={this.state.selectedRuns.some(a => a.runId === run.runId)} onChange={this.handleRunCheck} />
                        </td>
                        <td>
                            <input type="checkbox" value={index/*run.runId*/} id={`${run.runId}-graph`} checked={this.state.graphedRuns.some(a => a.runId === run.runId)} onChange={this.handleGraphRunCheck} />
                        </td>
                        <td>
                            <div className={"display-flex"}>
                                <div className={"color-picker-wrapper"} style={{ backgroundColor: this.state.runData[run.runId] !== undefined ? this.state.runData[run.runId].color : '#ffffff' }} onClick={() => this.handleColorClick(run.runId)} />
                                {this.state.showColorPicker && this.state.selectedColor === run.runId ?
                                    <div className={"color-picker-inner-wrapper"}>
                                        <div onClick={this.closeColorPicker} className={"color-picker"} />
                                        <SketchPicker color={this.state.runData[run.runId] !== undefined ? this.state.runData[run.runId].color : '#ffffff'} onChange={this.handleColorChange} />
                                    </div>
                                    : null
                                }
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
            : <tbody>
                <tr><td>{this.state.runTableLoading || this.state.loading ? "Loading Runs for Selected Device..." : "No Runs for this Device"}</td></tr>
            </tbody>;

        let runTable = this.state.runAssetSelected ?
            <div className={"max-height-330 margin-bottom-15 overflow-auto"}>
                <table className='table table-striped table-bordered table-sm table-hover' aria-labelledby="tabelLabel">
                    <thead>
                        <tr>
                            <th>Run Id</th>
                            <th>Start Time</th>
                            <th>End Time </th>
                            <th>Alert Type</th>
                            <th>Select <input type="checkbox" value={this.state.allSelected} checked={this.state.allSelected} id='selectAll' onChange={this.onSelectAll} className={"margin-left-5"} /></th>
                            <th>Graph <input type="checkbox" value={this.state.allGraphed} checked={this.state.allGraphed} id='graphAll' onChange={this.onGraphAll} className={"margin-left-5"} /></th>
                            <th className={"width-25"}></th>
                        </tr>
                    </thead>
                    {tableContent}
                </table>
            </div>
            : <div>{null}</div>;

        return (
            <div className={"pad-left-10 pad-top-5"}>
                <div className="row no-gutters display-flex">
                    <div className="col-sm-12 col-md-4">

                        <div className="min-height-100p-sub-10 grey-container">
                            <h5 className="sectionTitle">
                                <button className="tertiary-btn margin-0" onClick={this.onBackClick}>{"<"}</button>
                                Alert Type: {this.state.currentAlertType}
                            </h5>
                            <div className="table-container">
                                <div className={"margin-bottom-0 overflow-auto"}>
                                    <table className='table table-striped table-bordered table-sm table-hover' aria-labelledby="tabelLabel">
                                        <thead>
                                            <tr>
                                                <th>Device Id</th>
                                                <th>Failed Run Count</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.currentAlert.alertAssets.length ?
                                                this.state.currentAlert.alertAssets.map((asset, index) =>
                                                    <tr key={`${asset.deviceId}-${index}`} data={index} className={this.state.currentAssetId === asset.assetId ? "tableSelected" : ""} onClick={() => { this.onAlertAssetClick(asset.assetId) }}>
                                                        <td>{asset.deviceId}</td>
                                                        <td>{asset.failedRunCount}</td>
                                                    </tr>
                                                )
                                                : <tr><td>No Assets for this Alert Type!</td></tr>
                                            }
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12 col-md-8">

                        <div className="white-container min-height-100p">
                            <h5 className="sectionTitle">Device Runs</h5>
                            <div className="max-height-330 table-container">
                                {runTable}
                            </div>
                            {alertLoader}
                        </div>
                    </div>
                </div>

                <div>
                    {this.state.runAssetSelected ?
                        <div>
                            <br />
                            {this.renderGraph()}
                        </div>
                        : <div className="centered">
                            <br />
                            Select a Device to generate graph
                            </div>
                    }
                    <p>{this.state.message}</p>
                </div>
            </div>
        );
    }

    renderTrainingContent() {
        let tableList = this.state.columnAltered ? this.state.columnList : this.state.trainingList;

        let tableContent = tableList.length ?
            <tbody>
                {this.state.trainingList.map((alert, index) =>
                    <tr className="alerts-table-row" key={`${alert.alertType}-tableRow`} data={index} value={index} onClick={() => this.onAlertRowClick(index)}>
                        <td className={"border-left pad-left-30"}>{alert.alertType}</td>
                        <td>{alert.assetCount}</td>
                        <td>{this.getAssetPercentage(alert.assetCount)}</td>
                        <td>{alert.runCount}</td>
                        <td className={"border-right"}>{this.getRunPercentage(alert.runCount)}</td>
                    </tr>
                )}
            </tbody>
            :
            <tbody>
                <tr>
                    <td>No Alerts to Show!</td>
                </tr>
            </tbody>;


        let arrowIcon = this.state.columnSort.enabled ?
            (this.state.columnSort.reverse ?
                <LongArrowDownIcon style={{ height: '16px', width: '15px', paddingBottom: '2px' }} />
                : <LongArrowUpIcon style={{ height: '16px', width: '15px', paddingBottom: '2px' }} />)
            : null;

        let alertTypeIcon = this.state.columnSort.enabled && this.state.columnSort.type === "ALERTTYPE" ?
            <span className={"column-icon"}>
                {arrowIcon}
            </span>
            : null;

        let assetCountIcon = this.state.columnSort.enabled && this.state.columnSort.type === "ASSETCOUNT" ?
            <span className={"column-icon"}>
                {arrowIcon}
            </span>
            : null;

        let assetPercentageIcon = this.state.columnSort.enabled && this.state.columnSort.type === "ASSETPERCENTAGE" ?
            <span className={"column-icon"}>
                {arrowIcon}
            </span>
            : null;

        let runCountIcon = this.state.columnSort.enabled && this.state.columnSort.type === "RUNCOUNT" ?
            <span className={"column-icon"}>
                {arrowIcon}
            </span>
            : null;

        let runPercentageIcon = this.state.columnSort.enabled && this.state.columnSort.type === "RUNPERCENTAGE" ?
            <span className={"column-icon"}>
                {arrowIcon}
            </span>
            : null;

        return (
            <div>
                <div className="row no-gutters alerts-tab-wrapper alerts-top-tabs">
                    <div className="col"></div>
                    <div className="col-4 pad-top-15">
                        <p>Assets in Training Session: &nbsp;<b>{this.state.alertCountInfo.assetCount}</b></p>
                        <p>Runs Observed: &nbsp;<b>{this.state.alertCountInfo.runCount}</b></p>
                    </div>
                    <div className="col-4 pad-top-15">
                        <p>Training Session Date: &nbsp;<b>{this.state.alertCountInfo.trainingSessionDate}</b></p>
                        <p>Training Session Id: &nbsp;<b>{this.state.alertCountInfo.trainingSessionId}</b></p>
                    </div>
                    <div className="col"></div>
                </div>

                <div className={"margin-20-30"}>

                    <div>
                        <table className="table-hover width-100p">

                            <thead>
                                <tr className="alerts-table-row">
                                    <th className={"pad-left-30"}>
                                        <div onClick={() => this.onColumnClick("ALERTTYPE")}>
                                            <span className={"cursor-pointer"}>ALERT TYPE</span>
                                            {alertTypeIcon}
                                        </div>
                                    </th>
                                    <th>
                                        <div onClick={() => this.onColumnClick("ASSETCOUNT")}>
                                            <span className={"cursor-pointer"}># ASSETS WITH ALERT</span>
                                            {assetCountIcon}
                                        </div>
                                    </th>
                                    <th>
                                        <div onClick={() => this.onColumnClick("ASSETPERCENTAGE")}>
                                            <span className={"cursor-pointer"}>PERCENTAGE OF ALERT</span>
                                            {assetPercentageIcon}
                                        </div>
                                    </th>
                                    <th>
                                        <div onClick={() => this.onColumnClick("RUNCOUNT")}>
                                            <span className={"cursor-pointer"}>NUMBER OF RUNS WITH FAILURE</span>
                                            {runCountIcon}
                                        </div>
                                    </th>
                                    <th>
                                        <div onClick={() => this.onColumnClick("RUNPERCENTAGE")}>
                                            <span className={"cursor-pointer"}>PERCENTAGE OF RUNS WITH FAILURE</span>
                                            {runPercentageIcon}
                                        </div>
                                    </th>
                                </tr>
                            </thead>

                            {tableContent}

                        </table>
                    </div>
                </div>

            </div>
        );
    }

    render() {
        const { classes } = this.props;

        let loader = this.state.loading ?
            <Loader />
            : null;

        let title = this.state.alertSelected ? this.state.currentAlertType + " Training Review" : "Furnace Training Alert Count Review";
        let contents = this.state.alertSelected ? this.renderAlertContent() : this.renderTrainingContent();

        let showAllBtn = !this.state.alertSelected && this.state.showShowAllBtn ?
            <div className="btn-right pad-25-0-0-30">
                <button className={this.state.showAllTraining ? "primary-btn btn-large width-150" : "secondary-btn btn-large width-150"} onClick={this.onShowAllClick}>Show All</button>
            </div>
            : null;

        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: '-225px !important',
                },
            })}>
                <div className='infoPage'>
                    <div className="row no-gutters">
                        <div className="col">
                            <h2 className="pageTitle dashboard-title" id="tabelLabel">
                                {title}
                            </h2>
                        </div>
                        <div className="col">
                            {showAllBtn}
                        </div>
                    </div>

                    {contents}
                    {loader}

                </div>
            </div>
        );
    }

}

export default FuranceAlertTrainingReview;